import React, { useEffect } from "react";
import ReactGA from "react-ga4";

import {
  useLocation,
  BrowserRouter as Router, // Use BrowserRouter for most use cases
} from "react-router-dom";
import MobileAppPopup from "./components/MobileAppPopup/MobileAppPopup";
import routes from "./routes";

const App = () => {
  // Automatically change direction based on language
  // useEffect(() => {
  //   document.documentElement.setAttribute("dir", i18n.language === "ur" ? "rtl" : "ltr");
  // }, [i18n.language]);

  return (
    <>
      <Router>
        <AppContent />
      </Router>
    </>
  );
};

const AppContent = () => {
  const location = useLocation();

  return (
    <>
      <PageViews />
      <MobileAppPopup key={location.pathname + location.search} />
      {routes}
    </>
  );
};

const PageViews = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default App;

// #083555 dark blue
// #EF4723 Orange
// 083555 dark 1275BB light gradient
// 656565 dark grey text color
